import "./component.scss";

const $$getModal = () => $(document.querySelector(".js-borneo-no-access-modal"));

const init = () => {
  $$getModal().modal("show");
};

export default init;
